import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import DebugBarControl from '../../../../library/SimpleControls/DebugBarControl';
import { axiosClient } from '../../../../library/Service/axiosClient';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import InternalAdminQRReportService from './InternalAdminQRReportService';
import useSmartState from '../../../../common/hooks/useSmartState';

const ViewQRUpdationModal = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const showFlag = state?.modalFlags?.showQRUpdationModal;
    const { setStateValue } = useSmartState();

    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
    const [selectedUUID, setSelectedUUID] = useState('');

    const studentData = state?.data?.alumniList?.find((student: any) => student.id === state?.data?.selectedId);

    const loadOptions = async (inputValue: string) => {
        if (isEmpty(inputValue) || inputValue.length <= 2) {
            return [];
        }
        try {
            const response = await axiosClient().get(
                `${process.env.REACT_APP_REPORTS_SERVER}/common/list-for-name-search?term=${inputValue}&callFrom=qr_code_checkins`
            );
            const userData = response.data?.students || [];
            // Assuming your API response contains an array of options
            return userData.map((option: any) => ({
                value: option.uuid,
                label: `${option.firstName} ${option?.lastName}, ${option?.schoolName} ${option?.programName ? ',' + option?.programName : ''} ${option?.passOutYear ? ',' + option?.passOutYear : ''}`,
                uuid: option.uuid,
                firstName: option.firstName,
                passOutYear: option.passOutYear,
                lastName: option.lastName,
                name: option.lastName,
                profilePictureFilePath: option.profilePictureFilePath,
                mobile: option.mobile,
                registeredEmailId: option.registeredEmailId,
                universityId: option.universityId,
                companyName: option.companyName,
                profileImage: option.profileImage,
                userTypeCode: option.userTypeCode,
                programName: option.programName,
                programId: option.programId,
                designation: option.designation,
                schoolName: option.schoolName,
            }));
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleSave = async (event: any) => {
        event.preventDefault();
        if(!selectedUUID) {
            alert('Select a User');
            return;
        };
        
        try {
            const response = await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/search/qr-code-map-and-save`,
                {
                    idList: state?.data?.selectedId,
                    uuid: selectedUUID
                }
            );

            dispatch({
                type: 'TOGGLE_MODAL_VISIBILITY',
                payload: { modalName: 'showQRUpdationModal' }
            });

            Swal.fire("Updated Successfully");

            const defaultCriteria = InternalAdminQRReportService.getDefaultSearchCriteria(state.routeInfo.pageName);
            setStateValue('searchCriteria', defaultCriteria);

        } catch (error) {
            console.error(error);
            Swal.fire("Something went wrong!");
        }
    }

    return (
        <div
            id="update-profilemarkerlogs-data"
            className={`modal fade ${showFlag ? 'show' : ''}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showFlag ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} >
            <div className="modal-dialog modal-dialog-centered max-800 mx-auto">
                <div className="modal-content">
                    <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                        <h5 className="modal-title" id="staticBackdropLabel">Select Alumni</h5>
                        <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showQRUpdationModal' } });
                            }}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body p-4">
                        {studentData && (
                            <div className="mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Alumni Name : {studentData.name}</label>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Email : {studentData.emailId}</label>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Contact : {studentData.contact}</label>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Passout Year : {studentData.passoutYear}</label>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Program Name : {studentData.programName}</label>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="recipient-name" className="col-form-label">Institute Name : {studentData.schoolName}</label>
                                    </div>

                                    <div className="col-md-12">
                                        <AsyncSelect
                                            isClearable={false}
                                            onChange={(option) => {
                                                setSelectedUUID(option?.uuid);
                                                setSelectedOptions(option);
                                            }}
                                            components={{
                                                        DropdownIndicator: null,
                                                        IndicatorSeparator: null
                                                    }}
                                            loadOptions={loadOptions}
                                            placeholder={`Click here to Search by Name`}
                                            value={selectedOptions}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary me-2" onClick={() => {
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showQRUpdationModal' } });
                            }}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={handleSave}>Submit</button>
                        </div>
                    </div>
                    <DebugBarControl />
                </div>
            </div>
        </div>
    );
};

export default ViewQRUpdationModal;
